'use strict';

/**
 *
 * @name: nnModules
 *
 */

function NnModulesDirective($compile) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      modules: '=nnModules'
    },
    template: '<div class="custom-modules"></div>',
    link: function(scope, element) {

      /**
       *
       * @PRIVATE_METHODS
       *
       */

      function _spinnerTemplate(index) {

        return '<div ng-if="!loaded[' + index + ']" data-spinner class="module-inner"></div>';
      }

      function _moduleTemplate(index, name, inner) {

        return '<div data-loaded="loaded[' + index + ']" data-' + name + ' data-content="modules.items[' + index + ']">' + inner + '</div>';
      }

      function _runModules() {

        scope.modules.items.forEach(function(item, index) {

          var hyphenCase = item.type.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();

          scope.loaded = [];
          scope.loaded[index] = false;

          var spinner = _spinnerTemplate(index);
          var module = _moduleTemplate(index, hyphenCase, spinner);

          angular.element(element).html(angular.element(element).html() + module);
        });

        $compile(element.contents())(scope);
      }

      function _watchModules() {

        scope.$watch('modules', function(newVal) {

          if (newVal) {

            if (Object.keys(newVal).length === 0) {

              element.html('');
            } else {

              _runModules();
            }
          }
        });
      }

      /**
       *
       * @INIT
       *
       */

      _watchModules();
    }
  };
}

export default NnModulesDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-modules.directive.js